import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export const rerunAllFormValidators = (form: FormGroup | FormArray) => {
  Object.keys(form.controls).forEach((key) => {
    const control = (form.controls as { [key: string]: AbstractControl<any, any> })[key];

    // Recurse into nested groups/arrays
    if (control instanceof FormGroup || control instanceof FormArray) {
      rerunAllFormValidators(control);
    } else {
      control.updateValueAndValidity({ onlySelf: true });
    }
  });
};
